<div class="flex h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start justify-between px-6" [ngClass]="shortScreen ? 'pt-3 pb-2' : 'pt-6 pb-4'">
    <div class="min-w-0">
      <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.TITLE' | t }}</h2>
      @if (!shortScreen) {
      <p class="text-secondary text-sm">
        <span [innerHTML]="'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.SUBTITLE' | t: { count: documents.length }"></span>
      </p>
      }
    </div>
    <button mat-icon-button type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- maestro y detalle: la lista crece con el número de documentos, el detalle no -->
  <div class="flex min-h-0 flex-1 flex-col border-t md:flex-row">
    <!-- móvil: el documento se elige en un desplegable -->
    <div class="shrink-0 border-b px-4 py-3 md:hidden">
      <mat-form-field class="w-full" subscriptSizing="dynamic">
        <mat-label>{{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.DOCUMENT_LABEL' | t }}</mat-label>
        <mat-select [value]="selectedIndex" (selectionChange)="select($event.value)"
          panelClass="dg-wrap-panel">
          <mat-select-trigger>
            @if (selected) {
            <span class="flex flex-wrap items-center gap-x-2 gap-y-0.5">
              <span class="font-semibold">{{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.DOCUMENT_NUMBERED' | t: { number: selectedIndex + 1 } }}</span>
              @if (withoutRoute(selected)) {
              <mat-icon class="icon-size-4 text-amber-600 dark:text-amber-400"
                fontSet="material-icons-outlined">warning</mat-icon>
              }
              @if (selected.withoutStock) {
              <span class="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">
                {{ 'DOCUMENT_GENERATE.BADGES.NO_INVENTORY' | t }}
              </span>
              }
              <span class="text-secondary text-xs">
                {{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.LINES_COUNT' | t: { count: lineCount(selected) } }} ·
                {{ data.currency }}&nbsp;{{ selected.summary.total | dgNumber }}
              </span>
            </span>
            }
          </mat-select-trigger>
          @for (doc of documents; track $index) {
          <mat-option [value]="$index">
            <span class="flex flex-col gap-0.5 py-1">
              <span class="flex flex-wrap items-center gap-1.5">
                <span class="font-semibold">{{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.DOCUMENT_NUMBERED' | t: { number: $index + 1 } }}</span>
                @if (withoutRoute(doc)) {
                <mat-icon class="icon-size-4 text-amber-600 dark:text-amber-400"
                  fontSet="material-icons-outlined">warning</mat-icon>
                }
                @if (doc.withoutStock) {
                <span class="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">
                  {{ 'DOCUMENT_GENERATE.BADGES.NO_INVENTORY' | t }}
                </span>
                }
              </span>
              @if (doc.warehouseLabel) {
              <span class="text-secondary text-xs uppercase">{{ doc.warehouseLabel }}</span>
              }
              <span class="flex items-center gap-2 text-xs">
                <span class="text-secondary">
                  {{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.LINES_COUNT' | t: { count: lineCount(doc) } }}
                </span>
                <span class="font-semibold">{{ data.currency }}&nbsp;{{ doc.summary.total | dgNumber }}</span>
              </span>
            </span>
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- desde md: lista de documentos como panel lateral -->
    <div class="hidden shrink-0 overflow-auto border-b md:block md:max-h-none md:w-72 md:border-b-0 md:border-r">
      @for (doc of documents; track $index) {
      <button type="button" class="w-full border-b px-4 py-3 text-left transition-colors"
        [class.bg-primary-50]="$index === selectedIndex"
        [class.dark:bg-primary-900]="$index === selectedIndex"
        [class.hover:bg-gray-50]="$index !== selectedIndex"
        [class.dark:hover:bg-gray-800]="$index !== selectedIndex"
        (click)="select($index)">
        <div class="flex items-center justify-between gap-2">
          <span class="flex min-w-0 items-center gap-1">
            <span class="truncate font-semibold" [class.text-primary]="$index === selectedIndex">
              {{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.DOCUMENT_NUMBERED' | t: { number: $index + 1 } }}
            </span>
            @if (withoutRoute(doc)) {
            <mat-icon class="icon-size-4 shrink-0 text-amber-600 dark:text-amber-400"
              fontSet="material-icons-outlined" [matTooltip]="'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.NO_ROUTE_TOOLTIP' | t">warning</mat-icon>
            }
          </span>
          @if (doc.withoutStock) {
          <span class="shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">
            {{ 'DOCUMENT_GENERATE.BADGES.NO_INVENTORY' | t }}
          </span>
          }
        </div>
        @if (doc.warehouseLabel) {
        <div class="text-secondary mt-0.5 truncate text-xs uppercase" [matTooltip]="doc.warehouseLabel">
          {{ doc.warehouseLabel }}
        </div>
        }
        <div class="mt-1 flex items-center justify-between gap-2 text-xs">
          <span class="text-secondary">
            {{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.LINES_COUNT' | t: { count: lineCount(doc) } }}
          </span>
          <span class="font-semibold">{{ data.currency }}&nbsp;{{ doc.summary.total | dgNumber }}</span>
        </div>
      </button>
      }
    </div>

    <!-- detalle del documento seleccionado -->
    <div class="flex min-h-0 min-w-0 flex-1 flex-col">
      @if (selected) {
      <div class="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
        <h3 class="text-base font-bold">
          {{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.DOCUMENT_OF' | t: { number: selectedIndex + 1, total: documents.length } }}
        </h3>
        @if (selected.warehouseLabel) {
        <span class="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium dark:bg-gray-700">
          <mat-icon class="icon-size-4">warehouse</mat-icon>
          {{ selected.warehouseLabel }}
        </span>
        }
      </div>

      <!-- por qué este documento quedó separado del resto -->
      @if (selected.splitReasons?.length) {
      <div class="flex flex-wrap items-center gap-2 px-6 pb-3">
        <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.SPLIT_REASON' | t }}</span>
        @for (reason of selected.splitReasons; track reason) {
        <span class="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700 dark:bg-blue-900/40 dark:text-blue-300">
          {{ reasonLabel(reason) }}
        </span>
        }
        @if (selected.windowDaysLabel) {
        <span class="text-secondary text-xs">
          {{ 'DOCUMENT_GENERATE.SPLIT_MODAL.ALLOWED_DAYS' | t }}: {{ selected.windowDaysLabel }}
        </span>
        }
      </div>
      }

      <!-- ruta del documento: cada uno puede entregarse por una distinta -->
      @if (hasRouteResolution(selected)) {
      <div class="border-t px-6 py-3">
        @if (selected.routeName) {
        <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
          <span class="flex items-center gap-1.5 font-semibold uppercase">
            <mat-icon class="text-primary icon-size-5" fontSet="material-icons-outlined">local_shipping</mat-icon>
            {{ selected.routeName }}
          </span>
          @if (selected.tripLabel) {
          <span class="text-secondary text-sm">{{ selected.tripLabel }}</span>
          }
          @if (selected.deliveryDate) {
          <span class="text-secondary flex items-center gap-1 text-sm">
            <mat-icon class="icon-size-4" fontSet="material-icons-outlined">event_available</mat-icon>
            {{ selected.deliveryDate | date:'dd/MM/yyyy' }}
          </span>
          }
          @if (canChangeRoute(selected)) {
          <button mat-stroked-button color="primary" type="button" class="ml-auto" (click)="changeRoute()">
            <mat-icon class="icon-size-4">alt_route</mat-icon>
            {{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.CHANGE_ROUTE' | t }}
          </button>
          }
        </div>
        } @else {
        <div class="flex items-start gap-2 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 dark:border-amber-700 dark:bg-amber-950">
          <mat-icon class="icon-size-5 shrink-0 text-amber-600 dark:text-amber-400"
            fontSet="material-icons-outlined">warning</mat-icon>
          <div class="text-sm leading-relaxed text-amber-900 dark:text-amber-100">
            <b>{{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.NO_ROUTE_TITLE' | t }}</b>
            {{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.NO_ROUTE_HINT' | t }}
          </div>
        </div>
        }
      </div>
      }

      <!-- móvil: tarjetas -->
      <div class="min-h-0 flex-1 overflow-auto border-t p-3 md:hidden">
        <div class="flex flex-col gap-3">
          @for (item of selected.items; track item.lineId) {
          <div class="flex flex-col rounded-xl border bg-card p-3">
            <div class="flex min-w-0 flex-col">
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.LINE_NUMBER' | t: { index: $index + 1 } }}</span>
              <span class="text-primary font-semibold">{{ item.code }}</span>
              <span class="text-sm uppercase">{{ item.name }}</span>
              @if (warehouseLabel(item)) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.WAREHOUSE_PREFIX' | t }} {{ warehouseLabel(item) }}</span>
              }
            </div>

            <div class="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 border-t pt-3 text-sm">
              <div class="col-span-2 flex items-center justify-between gap-2">
                <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</span>
                <span class="flex items-center gap-1">
                  <span class="font-semibold">{{ quantityText(item) }}</span>
                  @if (item.bonusIncludedQty) {
                  <span class="rounded-full bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900 dark:text-green-300"
                    [matTooltip]="'DOCUMENT_GENERATE.SPLIT_MODAL.BONUS_TOOLTIP' | t">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.BONUS_CHIP' | t: { count: item.bonusIncludedQty } }}</span>
                  }
                </span>
              </div>
              <div class="col-span-2 flex items-center justify-between gap-2">
                <span class="text-secondary shrink-0">UMV</span>
                <div class="flex min-w-0 flex-col items-end">
                  <span class="min-w-0 truncate" [matTooltip]="item.unitLabel">{{ item.unitLabel }}</span>
                  @if (altUnits(item); as alt) {
                  <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: (alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode } }}</span>
                  @if (alt.umsQty != null) {
                  <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: (alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode } }}</span>
                  }
                  @if (alt.umpQty != null) {
                  <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: (alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode } }}</span>
                  }
                  }
                </div>
              </div>
              <div class="col-span-2 flex items-center justify-between gap-2 border-t pt-2">
                <span class="text-secondary font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TOTAL' | t }}</span>
                <span class="text-primary text-base font-bold">{{ data.currency }}&nbsp;{{ rowTotal(item) | dgNumber }}</span>
              </div>
            </div>
          </div>
          } @empty {
          <div class="text-secondary flex h-24 items-center justify-center text-sm">{{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.EMPTY_ITEMS' | t }}</div>
          }
        </div>
      </div>

      <!-- desktop/tablet: tabla -->
      <div class="hidden min-h-0 flex-1 overflow-auto border-t md:block">
        <table class="w-full min-w-[880px] border-collapse text-sm">
          <thead class="sticky top-0 z-10 bg-gray-50 dark:bg-gray-800">
            <tr class="text-secondary text-left">
              <th class="w-px whitespace-nowrap px-3 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.LINE_SHORT' | t }}</th>
              <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRODUCT' | t }}</th>
              <th class="px-4 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</th>
              <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SALE_UOM' | t }}</th>
              <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TOTAL' | t }}</th>
            </tr>
          </thead>
          <tbody>
            @for (item of selected.items; track item.lineId) {
            <tr class="border-t">
              <td class="w-px whitespace-nowrap px-3 py-3 text-center">{{ $index + 1 }}</td>
              <td class="px-4 py-3">
                <div class="flex flex-col">
                  <span class="text-primary font-semibold">{{ item.code }}</span>
                  <span class="uppercase">{{ item.name }}</span>
                  @if (warehouseLabel(item)) {
                  <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.WAREHOUSE_PREFIX' | t }} {{ warehouseLabel(item) }}</span>
                  }
                </div>
              </td>
              <td class="px-4 py-3 text-center">
                <div class="flex flex-col items-center gap-1">
                  <span>{{ quantityText(item) }}</span>
                  @if (item.bonusIncludedQty) {
                  <span class="rounded-full bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900 dark:text-green-300"
                    [matTooltip]="'DOCUMENT_GENERATE.SPLIT_MODAL.BONUS_TOOLTIP' | t">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.BONUS_CHIP' | t: { count: item.bonusIncludedQty } }}</span>
                  }
                </div>
              </td>
              <td class="px-4 py-3 text-left">
                <div class="flex flex-col items-start">
                  <span class="inline-block max-w-[90px] truncate align-middle" [matTooltip]="item.unitLabel">
                    {{ item.unitLabel }}
                  </span>
                  @if (altUnits(item); as alt) {
                  <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: (alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode } }}</span>
                  @if (alt.umsQty != null) {
                  <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: (alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode } }}</span>
                  }
                  @if (alt.umpQty != null) {
                  <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: (alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode } }}</span>
                  }
                  }
                </div>
              </td>
              <td class="px-4 py-3 text-right font-semibold">
                {{ data.currency }}&nbsp;{{ rowTotal(item) | dgNumber }}
              </td>
            </tr>
            } @empty {
            <tr>
              <td [attr.colspan]="columnCount">
                <div class="text-secondary flex h-24 items-center justify-center text-sm">{{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.EMPTY_ITEMS' | t }}</div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="flex items-center justify-end gap-3 border-t px-6 py-3">
        <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.DOCUMENT_SPLIT_MODAL.DOCUMENT_TOTAL' | t }}</span>
        <span class="text-primary text-lg font-bold">
          {{ data.currency }}&nbsp;{{ selected.summary.total | dgNumber }}
        </span>
      </div>
      }
    </div>
  </div>

  <!-- footer -->
  <div class="flex justify-end border-t px-6" [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    <button mat-flat-button color="primary" type="button" (click)="close()">{{ 'GENERAL.CLOSE' | t }}</button>
  </div>
</div>
